// eslint-disable-next-line import/extensions -- package's exports map requires the .js suffix
import { shouldPolyfill } from '@formatjs/intl-segmenter/should-polyfill.js'
import cusswords from '../../../Give/utils/flaggedUserLibrary/cussDetector'
import { getBadActorFlagKey, setBadActorData } from './badActorStore'

/**
 * Checks a given string for the presence of too many spaces and updates the bad actor data accordingly.
 *
 * @param {string} string - The string to check for too many spaces.
 * @returns {boolean} - Returns true if the string has more profanity than the configured threshold, false otherwise.
 */
export default async function checkForProfanity(string) {
  if (typeof string !== 'string') {
    throw new Error('Argument must be a string')
  }
  const key = 'checkForProfanity'
  if (shouldPolyfill()) {
    // eslint-disable-next-line import/extensions -- package's exports map requires the .js suffix
    await import('@formatjs/intl-segmenter/polyfill-force.js')
  }
  try {
    const keyData = await getBadActorFlagKey(key)
    if (keyData?.enabled) {
      const segmenter = new Intl.Segmenter('en', { granularity: 'word' })
      const textArray = Array.from(segmenter.segment(string))
        .map((segment) => segment.segment)
        .filter((word) => word !== ' ' && word !== '')
        .map((word) => word.toLowerCase())
      const cusswordsArray = Object.keys(cusswords)
      const cusswordsArrayFiltered = cusswordsArray.filter((word) => textArray.includes(word))
      const data = {}
      data.pass = cusswordsArrayFiltered.length < keyData.threshhold
      data.editedTerm = string
      setBadActorData(key, data)
      return cusswordsArrayFiltered.length > 0
    }
  } catch (error) {
    // eat the error
  }
  return false
}
